import { FileSubmission, FileStatus } from '@/models/file-submission.tsx'
import Icon from '@/components/shared/Icon.tsx'
import { joinClasses } from '@/utils/styling'

export default function StatusSectionRejected({ 
    file
}: { 
    file: FileSubmission
}) {
    const status = FileStatus.get(file.CurrentStatus.toString()),
          statusText = status?.Text ?? '',
          iconColorClass = status?.TextColor ? `text-${status.TextColor}` : '';

    return (
        <div className="h-100 p-3 border">
            <div className="fs-5 d-flex align-items-center">
                <Icon name={status?.Icon} className={joinClasses('me-2', iconColorClass)} />
                <span className="me-2 flex-grow-1">Status: <span className="fw-bold">{statusText}</span></span>
            </div>
        </div>
    )
}